import { logoutCookies } from './Cookie';
import { navigateTo } from './Events';
import { WebLink } from './WebLinks';

export const endSession = async () => {
  await logoutCookies();
  navigateTo(WebLink.ERROR_FALLBACK);
};
